import React from 'react'
import DefaultLayoutHoc from '../layout/Default.layout'

const PlayPage = () => {
  return (
    <div>PlayPage</div>
  )
}

export default DefaultLayoutHoc(PlayPage)